import { registerDecorator, ValidationArguments, ValidationOptions, isEmail } from 'class-validator';

export function Match(property: string, validationOptions?: ValidationOptions) {
    return function (object: Object, propertyName: string) {
        registerDecorator({
            name: 'match',
            target: object.constructor,
            propertyName: propertyName,
            constraints: [property],
            options: validationOptions,
            validator: {
                validate(value: any, args: ValidationArguments) {
                    const [relatedPropertyName] = args.constraints;
                    const relatedValue = (args.object as any)[relatedPropertyName];
                    return value === relatedValue;
                },
                defaultMessage(args: ValidationArguments) {
                    const [relatedPropertyName] = args.constraints;
                    return `${propertyName} must match ${relatedPropertyName}`;
                },
            },
        });
    };
}

/**
 * Frontend-specific partial type utility
 * Returns class as-is for frontend builds (TypeScript handles Partial typing)
 */
export const ConditionalPartial = function <T>(BaseClass: new (...args: any[]) => T) {
    return BaseClass as any;
};

export function IsCommaSeparatedEmails(validationOptions?: ValidationOptions) {
    return function (object: Object, propertyName: string) {
        registerDecorator({
            name: 'isCommaSeparatedEmails',
            target: object.constructor,
            propertyName,
            options: validationOptions,
            validator: {
                validate(value: any) {
                    if (value === null || value === undefined || value === '') {
                        return true;
                    }

                    if (typeof value !== 'string') {
                        return false;
                    }

                    const emails = value
                        .split(',')
                        .map((email) => email.trim())
                        .filter((email) => email.length > 0);

                    return emails.length > 0 && emails.every((email) => isEmail(email));
                },
                defaultMessage() {
                    return `${propertyName} must contain comma-separated valid email addresses`;
                },
            },
        });
    };
}
